import { render, staticRenderFns } from "./SegmentName.vue?vue&type=template&id=a4f489f2&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/toshiya.murasaki/Docker/Laravel/TRIPLE-CROWN/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4f489f2')) {
      api.createRecord('a4f489f2', component.options)
    } else {
      api.reload('a4f489f2', component.options)
    }
    module.hot.accept("./SegmentName.vue?vue&type=template&id=a4f489f2&", function () {
      api.rerender('a4f489f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/member/common/Atoms/SegmentName.vue"
export default component.exports